import type { CalendarProviderCalendar } from '../store/schema/CalendarProviderCalendar';
import type { CalendarProviderType } from '../store/schema/CalendarProviderType';
import type { TeamSnapCalendar } from '../store/schema/TeamSnapCalendar';
import { getStore } from '../store/store';

export function getCalendarProviderCalendars(
    providerType: CalendarProviderType.TeamSnap
): TeamSnapCalendar[];
export function getCalendarProviderCalendars(
    providerType: CalendarProviderType
): CalendarProviderCalendar[];
export function getCalendarProviderCalendars(
    providerType: CalendarProviderType
): CalendarProviderCalendar[] {
    const store = getStore();

    const [providerAccount] = store.providerAccounts.filter(pa => pa.providerType === providerType);

    if (!providerAccount || !store.providerAccountCalendars.has(providerAccount.id)) {
        // No provider account was found or the calendars are not loaded so we return empty array
        return [];
    }

    return store.providerAccountCalendars.get(providerAccount.id);
}
